import { Badge } from "antd";
import React from "react";
import { useQuery } from "react-query";
import { api } from "../../services/Api";

const agentAssignedTaskCount = async () => {
  // Your fetch logic here
  return api.get("/tasks/count/agent-assigned");
};

const AgentAssignedTaskBadge = () => {
  const { data, isLoading, isError } = useQuery(
    "TasksCountOfAgentAssigned",
    agentAssignedTaskCount,
    {
      refetchInterval: 10 * 1000, // Refetch every 2 minutes
    }
  );

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching data</div>;

  return (
    <div>
      Agent Assigned Tasks{" "}
      <Badge
        overflowCount={Infinity} // This prevents the 99+ behavior
        showZero
        count={data?.data}
      ></Badge>
    </div>
  );
};

export default AgentAssignedTaskBadge;
